export default __webpack_public_path__ + "./images/val.28f1647b.png";